import { useGetSidebarConfigLazyQuery as _useGetSidebarConfigLazyQuery, useGetStatusLazyQuery as _useGetStatusLazyQuery, useGetStatusQuery as _useGetStatusQuery, } from "../generated/graphql-types";
export const useGetSidebarConfigLazy = (view_mode = 'all') => {
    const [getSidebarConfig, { data, error, loading },] = _useGetSidebarConfigLazyQuery({
        fetchPolicy: 'no-cache',
        variables: {
            viewMode: view_mode,
        },
    });
    return {
        error,
        loading,
        data: data?.Admin_getSidebarConfig,
        getSidebarConfig,
    };
};
export const useGetStatus = (view_mode = '', orgsEnabled = false, skip = false) => {
    const { data, error, loading, refetch } = _useGetStatusQuery({
        fetchPolicy: 'no-cache',
        skip,
        variables: {
            viewMode: view_mode,
            orgsEnabled,
        },
    });
    return {
        error,
        loading,
        data: data?.Admin_getStatus,
        refetch,
    };
};
export const useGetStatusLazy = (view_mode = '', orgsEnabled = false) => {
    const [getStatus, { data, error, loading }] = _useGetStatusLazyQuery({
        variables: {
            viewMode: view_mode,
            orgsEnabled,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Admin_getStatus,
        getStatus,
    };
};
//# sourceMappingURL=sidebar-service.js.map